module.exports = __webpack_public_path__ + "media/Video 6b.3dfffba4.mp4";